import { c as _c } from "react/compiler-runtime";
import { PaymentProcessorEnum } from '@systemeio/ui';
import { CONNECTED_PAYMENT_INTEGRATIONS_API } from 'modules/profile/payment-gateways/api/payment-gateways-api';
import { PaymentIntegrationsArrayType, PaymentIntegrationsType } from 'modules/profile/payment-gateways/types/connected-payment-integrations-interface';
import { useCallback } from 'react';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
interface ProcessorField {
  processor: PaymentProcessorEnum;
  matcher?: never;
}
interface MatcherField<T extends PaymentIntegrationsType> {
  matcher: (paymentProcessor: T['paymentProcessor']) => boolean;
  processor?: never;
}
type PaymentProcessorConfig<T extends PaymentIntegrationsType> = ProcessorField | MatcherField<T>;
export function useConnectedPaymentIntegrations() {
  const $ = _c(12);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== user) {
    t1 = () => {
      if (user) {
        return CONNECTED_PAYMENT_INTEGRATIONS_API;
      }
      return null;
    };
    $[1] = user;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: paymentIntegrations,
    mutate: mutatePaymentIntegrations
  } = useSWR(t1, fetcher);
  let t2;
  if ($[3] !== paymentIntegrations) {
    t2 = t3 => {
      const {
        matcher,
        processor
      } = t3;
      return paymentIntegrations?.find(integration => matcher ? matcher(integration.paymentProcessor) : integration.paymentProcessor === processor);
    };
    $[3] = paymentIntegrations;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const getConnectedPaymentIntegration = t2;
  let t3;
  if ($[5] !== mutatePaymentIntegrations) {
    t3 = t4 => {
      const {
        matcher: matcher_0,
        processor: processor_0
      } = t4;
      return mutatePaymentIntegrations(data => data && data.filter(integration_0 => matcher_0 ? matcher_0(integration_0.paymentProcessor) : integration_0.paymentProcessor !== processor_0), false);
    };
    $[5] = mutatePaymentIntegrations;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const removePaymentIntegration = t3;
  let t4;
  if ($[7] !== getConnectedPaymentIntegration || $[8] !== mutatePaymentIntegrations || $[9] !== paymentIntegrations || $[10] !== removePaymentIntegration) {
    t4 = {
      paymentIntegrations,
      mutatePaymentIntegrations,
      removePaymentIntegration,
      getConnectedPaymentIntegration
    };
    $[7] = getConnectedPaymentIntegration;
    $[8] = mutatePaymentIntegrations;
    $[9] = paymentIntegrations;
    $[10] = removePaymentIntegration;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}